// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3PKO4","row":"ProcedureTreatmentSummary_row__npFda"};